import { render } from "./MCancelButton.vue?vue&type=template&id=fa35a532&scoped=true"
import script from "./MCancelButton.vue?vue&type=script&lang=js"
export * from "./MCancelButton.vue?vue&type=script&lang=js"

import "./MCancelButton.vue?vue&type=style&index=0&id=fa35a532&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa35a532"]])

export default __exports__